module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"horse-and-tree\"-in-pomona-california-7e1fbf3425fc069510665d7962a12c8e.png";